<template>
    <div class="_fd-struct">
        <z-badge type="warning" is-dot :hidden="!configured">
            <div @click="visible=true">
                <slot>
                    <z-button class="_fd-plain-button" plain size="small">
                        {{ title || t('struct.title') }}
                    </z-button>
                </slot>
            </div>
        </z-badge>
        <z-dialog class="_fd-struct-con" :title="title || t('struct.title')" v-model="visible" destroy-on-close
                   :close-on-click-modal="false"
                   append-to-body width="800px">
            <div ref="editor" v-if="visible"></div>
            <template #footer>
                <div>
                    <z-button @click="visible = false" size="default">{{ t('props.cancel') }}</z-button>
                    <z-button type="primary" @click="onOk" size="default" color="#2f73ff">{{ t('props.ok') }}</z-button>
                </div>
            </template>
        </z-dialog>
    </div>
</template>

<script>
import 'codemirror/lib/codemirror.css';
import CodeMirror from 'codemirror/lib/codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/addon/display/placeholder';
import {deepParseFn, toJSON} from '../utils/index';
import {deepCopy} from '@form-create/utils/lib/deepextend';
import {defineComponent, markRaw} from 'vue';
import is from '@form-create/utils/lib/type';
import errorMessage from '../utils/message';
import beautify from 'js-beautify';

export default defineComponent({
    name: 'Struct',
    emits: ['update:modelValue'],
    props: {
        modelValue: [Object, Array, Function, String],
        title: String,
        placeholder: String,
        defaultValue: {
            require: false
        },
        validate: Function,
        text: Boolean,
    },
    inject: ['designer'],
    computed: {
        t() {
            return this.designer.setupState.t;
        },
        configured() {
            return !is.empty(this.modelValue) && Object.keys(this.modelValue).length > 0;
        },
    },
    data() {
        return {
            editor: null,
            visible: false,
            oldVal: null,
        };
    },
    watch: {
        modelValue() {
            this.load();
        },
        visible(n) {
            if (n) {
                this.load();
            }
        },
    },
    methods: {
        load() {
            const val = this.text
                ? this.modelValue || this.defaultValue
                : toJSON(deepParseFn(this.modelValue ? deepCopy(this.modelValue) : this.defaultValue));
            const placeholder = this.placeholder || '';
            this.oldVal = val;
            this.$nextTick(() => {
                this.editor = markRaw(CodeMirror(this.$refs.editor, {
                    lineNumbers: true,
                    mode: this.text ? 'null' : 'javascript',
                    lint: true,
                    line: true,
                    tabSize: 2,
                    lineWrapping: true,
                    placeholder,
                    value: val && !this.text ? beautify.js(val, {
                        indent_size: '2',
                        indent_char: ' ',
                        max_preserve_newlines: '5',
                        indent_scripts: 'separate',
                    }) : this.text ? (val || '') : '',
                }));
            });
        },
        onOk() {
            const str = (this.editor.getValue() || '').trim();
            let val;
            if (this.text) {
                val = str;
            } else {
                try {
                    val = (new Function('return ' + str))();
                } catch (e) {
                    console.error(e);
                    errorMessage(this.t('struct.errorMsg'));
                    return false;
                }
            }
            if (this.validate && false === this.validate(val)) {
                errorMessage(this.t('struct.errorMsg'));
                return false;
            }
            this.visible = false;
            if (toJSON(val, null, 2) !== this.oldVal) {
                this.$emit('update:modelValue', val);
            }
            return true;
        },
    }
});
</script>

<style>
._fd-struct {
    width: 100%;
}

._fd-struct .z-badge {
    width: 100%;
}

._fd-struct .z-button {
    font-weight: 400;
    width: 100%;
    border-color: #2E73FF;
    color: #2E73FF;
}

._fd-struct-con .CodeMirror {
    height: 500px;
}

._fd-struct-con .z-dialog__body {
    padding: 0px;
}
</style>
